import DOMPurify from 'dompurify';

// Sanitizes server-sourced rich text (Jodit-authored content, announcements, documents,
// emails, etc.) before it's handed to html-react-parser. DOMPurify's defaults strip
// <script>, event-handler attributes (onerror, onclick, ...), javascript: URLs, and other
// injectable content while keeping standard rich-text markup (headings, lists, tables,
// links, images) intact.
export default function sanitizeHtml(html) {
    return DOMPurify.sanitize(html ?? '');
}
